import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import {
  Search, MapPin, CalendarDays, Users, Globe, Heart, CalendarPlus, ArrowRight,
  Presentation, Store, Building2, Crown, Handshake, Wrench, GraduationCap,
  Factory, ShoppingCart, TrendingUp, Mic, Loader2, Sparkles, Home, Compass, Gem, Plus,
} from "lucide-react";
import { api, API } from "../lib/api";

const HERO_IMG = "https://static.prod-images.emergentagent.com/jobs/315f67a0-df9f-4f8c-bd82-001e5f5d1a6a/images/dd33f780c57c9008bb9c6acf792c86d7489df52799b734a2132d8d8e363a80ef.jpeg";
const MAP_IMG = "https://static.prod-images.emergentagent.com/jobs/315f67a0-df9f-4f8c-bd82-001e5f5d1a6a/images/9eb8bdd309e65c60b2da5572be0bb5cb7e16885643b103232a182cbcce81cfb8.jpeg";

const SUGGESTIONS = [
  "Food & Beverage exhibitions in Dubai",
  "Automotive trade fairs in Frankfurt",
  "Renewable Energy summits in Abu Dhabi",
  "Healthcare congresses in Singapore",
  "Technology expos in Las Vegas",
];
const POPULAR = ["Manufacturing", "Healthcare", "Technology", "Renewable Energy", "Automotive", "Food & Beverage"];

const CATEGORIES = [
  { name: "Conferences", sub: "Knowledge & Leadership", icon: Presentation, type: "Conference" },
  { name: "Trade Fairs", sub: "Markets & Products", icon: Store, type: "Trade Fair" },
  { name: "Exhibitions", sub: "Companies & Technology", icon: Building2, type: "Exhibition" },
  { name: "Summits", sub: "Decision Makers", icon: Crown, type: "Summit" },
  { name: "B2B Meetings", sub: "Buyers & Suppliers", icon: Handshake, type: "B2B Meeting" },
  { name: "Business Forums", sub: "Industry Networking", icon: Users, type: "Business Forum" },
  { name: "Workshops", sub: "Skills & Expertise", icon: Wrench, type: "Workshop" },
  { name: "Seminars", sub: "Professional Learning", icon: GraduationCap, type: "Seminar" },
];

const INSIDE = [
  { title: "Companies", desc: "Discover exhibitors and participating businesses.", icon: Building2 },
  { title: "Buyers", desc: "Identify potential buyers and procurement opportunities.", icon: ShoppingCart },
  { title: "Suppliers", desc: "Find manufacturers, distributors and service providers.", icon: Factory },
  { title: "Investors", desc: "Discover companies and investment opportunities.", icon: TrendingUp },
  { title: "Speakers", desc: "Meet industry experts and thought leaders.", icon: Mic },
  { title: "Partnerships", desc: "Identify strategic collaboration opportunities.", icon: Handshake },
];

const INDUSTRY_IMAGES = {
  "Manufacturing": "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbmR1c3RyaWFsJTIwZmFjdG9yeSUyMG1hbnVmYWN0dXJpbmclMjBmbG9vcnxlbnwwfHx8fDE3ODc4MjY5NDB8MA&ixlib=rb-4.1.0&q=85",
  "Textile & Apparel": "https://images.unsplash.com/photo-1758269445774-61a540a290a6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBpbmR1c3RyaWFsJTIwZmFjdG9yeSUyMG1hbnVmYWN0dXJpbmclMjBmbG9vcnxlbnwwfHx8fDE3ODc4MjY5NDB8MA&ixlib=rb-4.1.0&q=85",
  "Construction": "https://images.unsplash.com/photo-1772298783095-be38fa901232?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBpbmR1c3RyaWFsJTIwZmFjdG9yeSUyMG1hbnVmYWN0dXJpbmclMjBmbG9vcnxlbnwwfHx8fDE3ODc4MjY5NDB8MA&ixlib=rb-4.1.0&q=85",
  "Infrastructure": "https://images.unsplash.com/photo-1772299121503-cd62a57e3a26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzOTB8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBpbmR1c3RyaWFsJTIwZmFjdG9yeSUyMG1hbnVmYWN0dXJpbmclMjBmbG9vcnxlbnwwfHx8fDE3ODc4MjY5NDB8MA&ixlib=rb-4.1.0&q=85",
  "Food & Beverage": "https://images.unsplash.com/photo-1775314054195-85f31de0c944?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwzfHxnbG9iYWwlMjBidXNpbmVzcyUyMGNvbmZlcmVuY2UlMjBleGhpYml0aW9uJTIwdHJhZGUlMjBmYWlyfGVufDB8fHx8MTc4Nzg2ODQ1fDA&ixlib=rb-4.1.0&q=85",
  "Healthcare": "https://images.unsplash.com/photo-1775902087078-ecee948a7c6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxnbG9iYWwlMjBidXNpbmVzcyUyMGNvbmZlcmVuY2UlMjBleGhpYml0aW9uJTIwdHJhZGUlMjBmYWlyfGVufDB8fHx8MTc4Nzg2ODQ1fDA&ixlib=rb-4.1.0&q=85",
  "Technology": "https://images.unsplash.com/photo-1632383380175-812d44ec112b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMGNvbmZlcmVuY2UlMjB0ZWNobm9sb2d5JTIwZXhoaWJpdGlvbnxlbnwwfHx8fDE3ODc4MjY5NDB8MA&ixlib=rb-4.1.0&q=85",
  "Electronics": "https://images.unsplash.com/photo-1711390811760-1e9f2ab28cb7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMGNvbmZlcmVuY2UlMjB0ZWNobm9sb2d5JTIwZXhoaWJpdGlvbnxlbnwwfHx8fDE3ODc4MjY5NDB8MA&ixlib=rb-4.1.0&q=85",
  "Automotive": "https://images.unsplash.com/photo-1569616724771-7abf027deca4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZyUyMHRlY2glMjBoZWFsdGhjYXJlJTIwYnVzaW5lc3MlMjBtZWV0aW5nfGVufDB8fHx8MTc4Nzg2ODQ1fDA&ixlib=rb-4.1.0&q=85",
  "Finance": "https://images.unsplash.com/photo-1560439514-4e9645039924?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMGNvbmZlcmVuY2UlMjB0ZWNobm9sb2d5JTIwZXhoaWJpdGlvbnxlbnwwfHx8fDE3ODc4MjY5NDB8MA&ixlib=rb-4.1.0&q=85",
  "Renewable Energy": "https://images.unsplash.com/photo-1761195696518-6384573549ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxnbG9iYWwlMjBidXNpbmVzcyUyMGNvbmZlcmVuY2UlMjBleGhpYml0aW9uJTIwdHJhZGUlMjBmYWlyfGVufDB8fHx8MTc4Nzg2ODQ1fDA&ixlib=rb-4.1.0&q=85",
  "Energy": "https://images.unsplash.com/photo-1761195696518-6384573549ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHw0fHxnbG9iYWwlMjBidXNpbmVzcyUyMGNvbmZlcmVuY2UlMjBleGhpYml0aW9uJTIwdHJhZGUlMjBmYWlyfGVufDB8fHx8MTc4Nzg2ODQ1fDA&ixlib=rb-4.1.0&q=85",
  "Pharma": "https://images.unsplash.com/photo-1653566031535-bcf33e1c2893?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwbWFudWZhY3R1cmluZyUyMHRlY2glMjBoZWFsdGhjYXJlJTIwYnVzaW5lc3MlMjBtZWV0aW5nfGVufDB8fHx8MTc4Nzg2ODQ1fDA&ixlib=rb-4.1.0&q=85",
  "Logistics": "https://images.unsplash.com/photo-1761195689615-9469b65dac01?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxnbG9iYWwlMjBidXNpbmVzcyUyMGNvbmZlcmVuY2UlMjBleGhpYml0aW9uJTIwdHJhZGUlMjBmYWlyfGVufDB8fHx8MTc4Nzg2ODQ1fDA&ixlib=rb-4.1.0&q=85",
};
const INDUSTRY_LIST = ["Manufacturing", "Automotive", "Food & Beverage", "Healthcare", "Pharma", "Technology", "Energy", "Renewables", "Construction", "Infrastructure", "Logistics", "Textile & Apparel", "Chemicals", "Agriculture", "Finance", "Real Estate", "Defence & Aerospace", "Electronics"];
const POOL_IMGS = Object.values(INDUSTRY_IMAGES);

const NETWORK_ROLES = ["CEO", "Founder", "Investor", "Buyer", "Procurement Head", "Manufacturer", "Distributor", "Industry Expert"];
const MATCH_INTERESTS = ["Buyers", "Suppliers", "Investors", "Distribution Partners", "Technology Partners", "New Markets", "Industry Knowledge"];
const OBJECTIVES = ["Find Buyers", "Source Suppliers", "Raise Investment", "Enter New Markets", "Build Partnerships", "Industry Intelligence"];

const fmt = (n) => (n >= 1000 ? `${Math.round(n / 1000)}k+` : `${n || 0}`);

function Counter({ value, label, testid }) {
  const ref = useRef(null);
  const [n, setN] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      obs.disconnect();
      const start = performance.now();
      const tick = (t) => {
        const p = Math.min(1, (t - start) / 1200);
        setN(Math.round(value * (1 - Math.pow(1 - p, 3))));
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, { threshold: 0.4 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [value]);
  return (
    <div ref={ref} className="text-center px-4 py-6" data-testid={testid}>
      <p className="font-mono text-2xl md:text-3xl font-bold text-gold">{n.toLocaleString()}+</p>
      <p className="mt-1.5 text-[10px] font-mono uppercase tracking-widest text-slate-500">{label}</p>
    </div>
  );
}

function EventCard({ e, saved, registered, expanded, onToggle, onSave, onRegister, testidPrefix }) {
  return (
    <div className="card-surface overflow-hidden group hover:border-gold/40 transition-colors flex flex-col" data-testid={`${testidPrefix}-${e.id}`}>
      <div className="relative h-44 overflow-hidden bg-navy-800">
        {e.image && <img src={e.image} alt={e.name} loading="lazy" className="w-full h-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-500" />}
        <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/30 to-transparent" />
        <span className="absolute top-3 left-3 bg-navy-950/80 border border-gold/40 text-gold text-[10px] font-mono uppercase tracking-widest px-2 py-1 rounded-sm">{e.type}</span>
        <div className="absolute top-3 right-3 flex gap-2">
          <button onClick={() => onSave(e)} data-testid={`${testidPrefix}-save-${e.id}`} aria-label="Save event"
            className={`w-8 h-8 rounded-sm bg-navy-950/80 border flex items-center justify-center transition-colors ${saved ? "border-gold text-gold" : "border-slate-700 text-slate-400 hover:text-gold hover:border-gold/50"}`}>
            <Heart size={14} fill={saved ? "currentColor" : "none"} />
          </button>
          <a href={`${API}/events/${e.id}/calendar`} data-testid={`${testidPrefix}-calendar-${e.id}`} aria-label="Add to calendar"
            className="w-8 h-8 rounded-sm bg-navy-950/80 border border-slate-700 text-slate-400 hover:text-gold hover:border-gold/50 flex items-center justify-center transition-colors">
            <CalendarPlus size={14} />
          </a>
        </div>
        <div className="absolute bottom-3 left-3 flex items-center gap-1.5 text-[11px] font-mono text-gold bg-navy-950/80 px-2 py-1 rounded-sm border border-slate-700">
          <CalendarDays size={11} /> {e.dates}
        </div>
      </div>
      <div className="p-5 flex flex-col gap-3 flex-1">
        <div>
          <h3 className="font-display text-lg font-semibold text-slate-100 group-hover:text-gold transition-colors leading-snug">{e.name}</h3>
          <p className="mt-1 flex items-center gap-1.5 text-xs text-slate-400"><MapPin size={12} className="text-gold" />{e.location || `${e.city}, ${e.country}`}</p>
        </div>
        <div className="grid grid-cols-4 gap-2 text-center border-y border-slate-800 py-2.5">
          {[["Exhibitors", e.exhibitors], ["Countries", e.countries_count], ["Attendees", e.expected_attendees], ["Opportunities", e.opportunities]].map(([l, v]) => (
            <div key={l}>
              <p className="font-mono text-sm font-bold text-slate-100">{fmt(v)}</p>
              <p className="text-[9px] font-mono uppercase tracking-wider text-slate-500 mt-0.5">{l}</p>
            </div>
          ))}
        </div>
        <div className="flex flex-wrap gap-1.5">
          <span className="text-[10px] font-mono uppercase tracking-widest text-techblue-light border border-techblue/30 px-2 py-0.5 rounded-sm">{e.industry}</span>
          {(e.tags || []).slice(0, 3).map((t) => (
            <span key={t} className="text-[10px] font-mono text-slate-500 border border-slate-700 px-2 py-0.5 rounded-sm">{t}</span>
          ))}
        </div>
        {expanded && (
          <div className="border border-gold/25 bg-gold/5 rounded-sm p-4 space-y-3" data-testid={`${testidPrefix}-intel-${e.id}`}>
            <p className="text-xs text-slate-400 leading-relaxed">{e.description}</p>
            <div className="grid grid-cols-3 gap-2 text-center">
              {[["Buyers", e.buyers], ["Suppliers", e.suppliers], ["Decision Makers", e.decision_makers], ["Connections", e.potential_connections], ["Opp. Score", e.opportunity_score], ["Audience", (e.audience || []).length]].map(([l, v]) => (
                <div key={l} className="bg-navy-900/60 rounded-sm py-2">
                  <p className="font-mono text-sm font-bold text-gold">{l === "Audience" ? v : fmt(v)}</p>
                  <p className="text-[9px] font-mono uppercase tracking-wider text-slate-500">{l}</p>
                </div>
              ))}
            </div>
            {(e.audience || []).length > 0 && <p className="text-[10px] font-mono text-slate-500">WHO ATTENDS: {e.audience.join(" · ")}</p>}
          </div>
        )}
        <div className="mt-auto flex gap-2 pt-2">
          <button onClick={() => onToggle(e.id)} data-testid={`${testidPrefix}-view-${e.id}`} className="btn-outline !px-4 !py-2 text-xs flex-1">
            {expanded ? "HIDE INTELLIGENCE" : "VIEW EVENT"}
          </button>
          <button onClick={() => onRegister(e)} data-testid={`${testidPrefix}-register-${e.id}`} disabled={registered}
            className={`btn-gold !px-4 !py-2 text-xs flex-1 ${registered ? "opacity-60 cursor-default" : ""}`}>
            {registered ? "REGISTERED" : "REGISTER"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Events() {
  const navigate = useNavigate();
  const [meta, setMeta] = useState(null);
  const [events, setEvents] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ q: "", industry: "", country: "", type: "", when: "upcoming" });
  const [searchQ, setSearchQ] = useState("");
  const [placeholder, setPlaceholder] = useState(SUGGESTIONS[0]);
  const [expandedId, setExpandedId] = useState("");
  const [savedIds, setSavedIds] = useState(new Set());
  const [registeredIds, setRegisteredIds] = useState(new Set());
  const [calTab, setCalTab] = useState("upcoming");
  const [match, setMatch] = useState({ industry: "", country: "", objective: "", interests: [] });
  const [matchResults, setMatchResults] = useState(null);
  const [matching, setMatching] = useState(false);
  const resultsRef = useRef(null);

  useEffect(() => {
    let i = 0;
    const t = setInterval(() => { i = (i + 1) % SUGGESTIONS.length; setPlaceholder(SUGGESTIONS[i]); }, 3200);
    return () => clearInterval(t);
  }, []);

  useEffect(() => { api.get("/events/meta").then((r) => setMeta(r.data)).catch(() => {}); }, []);

  const fetchEvents = (f) => {
    setLoading(true);
    const params = Object.fromEntries(Object.entries(f).filter(([, v]) => v));
    api.get("/events", { params })
      .then((r) => { setEvents(r.data); setTotal(r.data.length); })
      .catch(() => toast.error("Could not load events"))
      .finally(() => setLoading(false));
  };
  useEffect(() => { fetchEvents(filters); }, []); // eslint-disable-line

  const applyFilters = (f) => {
    setFilters(f);
    fetchEvents(f);
    resultsRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const heroSearch = (e) => {
    e.preventDefault();
    applyFilters({ ...filters, q: searchQ });
  };

  const needAuth = () => { toast.info("Sign in to continue — it's free"); navigate("/login"); };

  const onSave = async (e) => {
    try {
      await api.post(`/events/${e.id}/save`);
      setSavedIds((s) => new Set([...s, e.id]));
      toast.success(`Saved — ${e.name}`);
    } catch (err) { err.response?.status === 401 ? needAuth() : toast.error("Could not save event"); }
  };

  const onRegister = async (e) => {
    try {
      const { data } = await api.post(`/events/${e.id}/register`);
      setRegisteredIds((s) => new Set([...s, e.id]));
      toast.success(data.already ? "Already registered for this event" : `Registered — ${e.name}`);
    } catch (err) { err.response?.status === 401 ? needAuth() : toast.error("Registration failed"); }
  };

  const runMatch = async (e) => {
    e.preventDefault();
    setMatching(true);
    try {
      const { data } = await api.post("/events/match", match);
      setMatchResults(data);
    } catch { toast.error("Matching unavailable"); }
    finally { setMatching(false); }
  };

  const today = new Date().toISOString().slice(0, 10);
  const inDays = (d) => new Date(Date.now() + d * 86400000).toISOString().slice(0, 10);
  const calEvents = events.filter((e) => {
    if (calTab === "today") return e.start_date <= today && (e.end_date || e.start_date) >= today;
    if (calTab === "week") return e.start_date <= inDays(7);
    if (calTab === "month") return e.start_date <= inDays(31);
    return e.start_date <= inDays(93);
  });

  const spot = meta?.spotlight;
  const m = meta?.metrics;

  return (
    <div className="bg-navy-950" data-testid="events-page">
      {/* HERO */}
      <section className="relative overflow-hidden" data-testid="events-hero">
        <img src={HERO_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-950/70 via-navy-950/80 to-navy-950" />
        <div className="relative max-w-7xl mx-auto px-4 md:px-8 pt-20 pb-16 md:pt-28 md:pb-20">
          <p className="gold-kicker mb-4" data-testid="events-hero-kicker">International Events · Conferences · Trade Fairs</p>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.08] text-slate-100 max-w-3xl" data-testid="events-hero-headline">
            WHERE THE WORLD'S <span className="text-gold">BUSINESS</span> MEETS.
          </h1>
          <p className="mt-3 text-base md:text-lg font-semibold text-slate-300 tracking-wide">DISCOVER EVENTS. FIND INDUSTRIES. CONNECT WITH OPPORTUNITIES.</p>
          <p className="mt-3 text-sm md:text-base text-slate-400 max-w-2xl leading-relaxed">
            Explore international conferences, trade fairs, exhibitions and business meetings across industries and countries — then connect with the buyers, suppliers, investors and decision-makers inside them.
          </p>
          <form onSubmit={heroSearch} className="mt-8 max-w-2xl flex items-stretch bg-navy-900/90 backdrop-blur border border-slate-700 rounded-sm overflow-hidden focus-within:border-gold transition-colors" data-testid="events-hero-search">
            <span className="flex items-center pl-4 text-slate-500"><Search size={17} /></span>
            <input value={searchQ} onChange={(e) => setSearchQ(e.target.value)} placeholder={placeholder}
              data-testid="events-hero-search-input"
              className="flex-1 bg-transparent px-3 py-4 text-sm text-slate-100 placeholder:text-slate-500 focus:outline-none" />
            <button type="submit" data-testid="events-hero-search-button" className="btn-gold !rounded-none !px-6 text-xs">SEARCH</button>
          </form>
          <div className="mt-4 flex flex-wrap items-center gap-2" data-testid="events-hero-popular">
            <span className="text-[10px] font-mono uppercase tracking-widest text-slate-500 mr-1">Popular:</span>
            {POPULAR.map((p) => (
              <button key={p} onClick={() => { setSearchQ(p); applyFilters({ ...filters, q: p }); }} data-testid={`popular-${p.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="text-xs text-slate-400 border border-slate-700 hover:border-gold/50 hover:text-gold px-3 py-1.5 rounded-full transition-colors">{p}</button>
            ))}
          </div>
          <div className="mt-8 flex flex-wrap gap-3">
            <a href="#events-discovery" data-testid="hero-explore-events-btn" className="btn-gold text-xs">EXPLORE GLOBAL EVENTS <ArrowRight size={13} /></a>
            <Link to="/register" data-testid="hero-register-btn" className="btn-outline text-xs">REGISTER GLOBALLY</Link>
            <Link to="/events/organiser/register" data-testid="hero-organiser-btn" className="text-xs text-gold hover:text-gold-light font-mono uppercase tracking-widest flex items-center gap-1.5 px-2">Organise an event <ArrowRight size={12} /></Link>
          </div>
        </div>
      </section>

      {/* DISCOVERY COMMAND PANEL */}
      <section id="events-discovery" ref={resultsRef} className="max-w-7xl mx-auto px-4 md:px-8 -mt-2" data-testid="events-discovery">
        <div className="card-surface hairline-gold p-6 md:p-8">
          <div className="flex flex-wrap items-center justify-between gap-3 mb-6">
            <h2 className="font-display text-xl md:text-2xl font-bold text-slate-100">FIND THE RIGHT EVENT</h2>
            <span className="text-[10px] font-mono uppercase tracking-widest text-slate-500" data-testid="events-result-count">{loading ? "Searching…" : `${total} events in view`}</span>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
            {[
              ["industry", "All Industries", meta?.industries || []],
              ["country", "All Countries", meta?.countries || []],
              ["type", "All Types", meta?.types || []],
              ["when", "Any Date", [["upcoming", "Upcoming"], ["month", "This Month"], ["quarter", "Next 3 Months"], ["", "Any Date"]]],
            ].map(([key, label, options]) => (
              <select key={key} value={filters[key]} onChange={(e) => setFilters({ ...filters, [key]: e.target.value })}
                data-testid={`filter-${key}-select`}
                className="input-dark text-xs !py-3 appearance-none cursor-pointer">
                <option value="">{label}</option>
                {options.map((o) => Array.isArray(o)
                  ? <option key={o[0]} value={o[0]}>{o[1]}</option>
                  : <option key={o} value={o}>{o}</option>)}
              </select>
            ))}
            <button onClick={() => applyFilters(filters)} data-testid="search-events-btn" className="btn-gold text-xs !py-3 col-span-2 md:col-span-1">SEARCH EVENTS <ArrowRight size={13} /></button>
          </div>
        </div>

        {/* RESULTS GRID */}
        <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5" data-testid="events-grid">
          {events.map((e) => (
            <EventCard key={e.id} e={e} testidPrefix="event-card"
              saved={savedIds.has(e.id)} registered={registeredIds.has(e.id)} expanded={expandedId === e.id}
              onToggle={(id) => setExpandedId(expandedId === id ? "" : id)} onSave={onSave} onRegister={onRegister} />
          ))}
        </div>
        {!loading && events.length === 0 && (
          <div className="card-surface p-10 text-center mt-10" data-testid="events-empty">
            <p className="text-slate-400 text-sm">No events match these filters yet.</p>
            <button onClick={() => applyFilters({ q: "", industry: "", country: "", type: "", when: "upcoming" })} data-testid="events-reset-filters" className="btn-outline text-xs mt-4">RESET FILTERS</button>
          </div>
        )}
      </section>

      {/* CATEGORIES */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 mt-16" data-testid="event-categories">
        <h2 className="font-display text-2xl md:text-3xl font-bold text-slate-100 mb-2">EXPLORE BY FORMAT</h2>
        <p className="text-sm text-slate-400 mb-6">Every format is a different room of opportunities.</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
          {CATEGORIES.map((c) => (
            <button key={c.name} onClick={() => applyFilters({ ...filters, type: filters.type === c.type ? "" : c.type })} data-testid={`category-card-${c.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={`card-surface p-4 text-center group transition-all hover:-translate-y-1 hover:border-gold/40 ${filters.type === c.type ? "border-gold/60 bg-gold/5" : ""}`}>
              <c.icon size={20} className={`mx-auto mb-2.5 transition-colors ${filters.type === c.type ? "text-gold" : "text-slate-500 group-hover:text-gold"}`} />
              <p className="text-xs font-semibold text-slate-200">{c.name}</p>
              <p className="text-[9px] font-mono uppercase tracking-wider text-slate-500 mt-1">{c.sub}</p>
            </button>
          ))}
        </div>
      </section>

      {/* EVENT INTELLIGENCE SPOTLIGHT */}
      {spot && (
        <section className="max-w-7xl mx-auto px-4 md:px-8 mt-16" data-testid="event-intelligence">
          <p className="gold-kicker mb-3">Event Intelligence</p>
          <h2 className="font-display text-2xl md:text-3xl font-bold text-slate-100">MORE THAN EVENTS. BUSINESS INTELLIGENCE.</h2>
          <p className="mt-3 text-sm text-slate-400 max-w-2xl">Every event contains an ecosystem of companies, buyers, suppliers, investors, speakers and potential partners.</p>
          <div className="card-surface hairline-gold mt-8 overflow-hidden">
            <div className="grid lg:grid-cols-5">
              <div className="lg:col-span-2 relative min-h-[220px]">
                {spot.image && <img src={spot.image} alt={spot.name} className="absolute inset-0 w-full h-full object-cover opacity-70" />}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent to-navy-900/90 hidden lg:block" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-950 to-transparent lg:hidden" />
                <span className="absolute top-4 left-4 bg-gold text-navy-950 text-[10px] font-mono font-bold uppercase tracking-widest px-2.5 py-1 rounded-sm">Top Opportunity</span>
              </div>
              <div className="lg:col-span-3 p-6 md:p-8">
                <div className="flex flex-wrap items-center gap-3 text-[10px] font-mono uppercase tracking-widest text-slate-500">
                  <span className="text-gold">{spot.type}</span><span>·</span><span>{spot.industry}</span><span>·</span>
                  <span className="flex items-center gap-1"><CalendarDays size={11} />{spot.dates}</span>
                </div>
                <h3 className="mt-2 font-display text-2xl font-bold text-slate-100" data-testid="spotlight-name">{spot.name}</h3>
                <p className="mt-1 flex items-center gap-1.5 text-xs text-slate-400"><MapPin size={12} className="text-gold" />{spot.location}</p>
                <div className="mt-6 grid grid-cols-2 sm:grid-cols-5 gap-3" data-testid="spotlight-metrics">
                  {[["Exhibitors", spot.exhibitors], ["Buyers", spot.buyers], ["Suppliers", spot.suppliers], ["Decision Makers", spot.decision_makers], ["Connections", spot.potential_connections]].map(([l, v]) => (
                    <div key={l} className="bg-navy-900/70 border border-slate-800 rounded-sm p-3 text-center hover:border-gold/40 transition-colors">
                      <p className="font-mono text-lg font-bold text-gold">{fmt(v)}</p>
                      <p className="text-[9px] font-mono uppercase tracking-wider text-slate-500 mt-1">{l}</p>
                    </div>
                  ))}
                </div>
                <button onClick={() => { setExpandedId(spot.id); applyFilters({ ...filters, q: spot.name }); }} data-testid="spotlight-explore-btn" className="btn-gold text-xs mt-6">EXPLORE EVENT INTELLIGENCE <ArrowRight size={13} /></button>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* OPPORTUNITY LAYER */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 mt-16" data-testid="opportunity-layer">
        <h2 className="font-display text-2xl md:text-3xl font-bold text-slate-100 text-center">WHAT CAN YOU FIND INSIDE AN EVENT?</h2>
        <div className="mt-8 grid grid-cols-2 lg:grid-cols-3 gap-4">
          {INSIDE.map((c) => (
            <div key={c.title} className="card-surface p-6 group hover:-translate-y-1 hover:border-gold/40 transition-all" data-testid={`inside-${c.title.toLowerCase()}`}>
              <c.icon size={20} className="text-gold mb-3" />
              <h3 className="font-display text-base font-semibold text-slate-100">{c.title}</h3>
              <p className="mt-1.5 text-xs text-slate-400 leading-relaxed">{c.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* INDUSTRY GRID */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 mt-16" data-testid="industry-grid">
        <div className="flex flex-wrap items-end justify-between gap-3 mb-8">
          <div>
            <h2 className="font-display text-2xl md:text-3xl font-bold text-slate-100">ONE PLATFORM. MULTIPLE INDUSTRIES.</h2>
            <p className="mt-2 text-sm text-slate-400">Filter the global calendar by the industries that move your business.</p>
          </div>
          <Link to="/industries" data-testid="explore-industries-btn" className="btn-outline text-xs">EXPLORE ALL INDUSTRIES <ArrowRight size={12} /></Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
          {INDUSTRY_LIST.map((name, i) => {
            const img = INDUSTRY_IMAGES[name] || POOL_IMGS[i % POOL_IMGS.length];
            const active = filters.industry === name;
            return (
              <button key={name} onClick={() => applyFilters({ ...filters, industry: active ? "" : name })} data-testid={`industry-card-${name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`relative h-28 rounded-sm overflow-hidden group border transition-all hover:-translate-y-0.5 ${active ? "border-gold" : "border-slate-800 hover:border-gold/40"}`}>
                <img src={img} alt={name} loading="lazy" className="absolute inset-0 w-full h-full object-cover opacity-50 group-hover:opacity-65 group-hover:scale-105 transition-all duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-navy-950 via-navy-950/40 to-transparent" />
                <span className={`absolute bottom-2.5 left-3 text-xs font-semibold ${active ? "text-gold" : "text-slate-100"}`}>{name}</span>
              </button>
            );
          })}
        </div>
      </section>

      {/* COUNTRY DISCOVERY */}
      <section className="relative mt-16 overflow-hidden" data-testid="country-discovery">
        <img src={MAP_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-950/60 to-navy-950" />
        <div className="relative max-w-7xl mx-auto px-4 md:px-8 py-16">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-slate-100 text-center">EXPLORE EVENTS BY COUNTRY</h2>
          <p className="mt-2 text-sm text-slate-400 text-center">Live markets with upcoming business events on 10XGLOBAL.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-2.5 max-w-3xl mx-auto" data-testid="country-chips">
            {(meta?.countries || []).map((c) => (
              <button key={c} onClick={() => applyFilters({ ...filters, country: filters.country === c ? "" : c })} data-testid={`country-chip-${c.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className={`flex items-center gap-1.5 text-xs px-4 py-2 rounded-full border transition-colors ${filters.country === c ? "border-gold text-gold bg-gold/10" : "border-slate-700 text-slate-300 hover:border-gold/50 hover:text-gold"}`}>
                <Globe size={12} /> {c}
              </button>
            ))}
          </div>
          <p className="mt-8 text-center text-[10px] font-mono uppercase tracking-widest text-slate-500" data-testid="country-count">
            {m ? `${m.countries}+ countries with live events · expanding weekly` : "Loading markets…"}
          </p>
        </div>
      </section>

      {/* AI MATCHING */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 mt-16" data-testid="ai-matching">
        <div className="card-surface hairline-gold p-6 md:p-10">
          <div className="grid lg:grid-cols-2 gap-10">
            <div>
              <p className="gold-kicker mb-3 flex items-center gap-2"><Sparkles size={13} /> 10X AI Matching</p>
              <h2 className="font-display text-2xl md:text-3xl font-bold text-slate-100">LET 10XGLOBAL FIND YOUR NEXT OPPORTUNITY.</h2>
              <p className="mt-3 text-sm text-slate-400 leading-relaxed">Tell us your industry, target market and business objective. Our matching engine scores every live event against your goals.</p>
              <form onSubmit={runMatch} className="mt-6 space-y-4">
                <div className="flex flex-wrap gap-2" data-testid="ai-match-interests">
                  {MATCH_INTERESTS.map((i) => {
                    const on = match.interests.includes(i);
                    return (
                      <button type="button" key={i} onClick={() => setMatch({ ...match, interests: on ? match.interests.filter((x) => x !== i) : [...match.interests, i] })}
                        data-testid={`match-interest-${i.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                        className={`text-xs px-3.5 py-2 rounded-full border transition-colors ${on ? "border-gold text-gold bg-gold/10" : "border-slate-700 text-slate-400 hover:border-slate-500"}`}>{i}</button>
                    );
                  })}
                </div>
                <div className="grid sm:grid-cols-3 gap-3">
                  <select value={match.industry} onChange={(e) => setMatch({ ...match, industry: e.target.value })} data-testid="match-industry-select" className="input-dark text-xs !py-3">
                    <option value="">Primary Industry</option>
                    {(meta?.industries?.length ? meta.industries : INDUSTRY_LIST).map((i) => <option key={i} value={i}>{i}</option>)}
                  </select>
                  <select value={match.country} onChange={(e) => setMatch({ ...match, country: e.target.value })} data-testid="match-country-select" className="input-dark text-xs !py-3">
                    <option value="">Target Country</option>
                    {(meta?.countries || []).map((c) => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <select value={match.objective} onChange={(e) => setMatch({ ...match, objective: e.target.value })} data-testid="match-objective-select" className="input-dark text-xs !py-3">
                    <option value="">Business Objective</option>
                    {OBJECTIVES.map((o) => <option key={o} value={o}>{o}</option>)}
                  </select>
                </div>
                <button type="submit" disabled={matching} data-testid="ai-match-submit-btn" className="btn-gold text-xs !px-7 !py-3.5">
                  {matching ? <Loader2 size={13} className="animate-spin" /> : <>FIND MY EVENTS <ArrowRight size={13} /></>}
                </button>
              </form>
            </div>
            <div className="bg-navy-900/60 border border-slate-800 rounded-sm p-5 md:p-6" data-testid="ai-match-results">
              {!matchResults && (
                <div className="h-full flex flex-col items-center justify-center text-center py-14">
                  <Sparkles size={22} className="text-gold mb-3" />
                  <p className="text-sm text-slate-400">Your matched events will appear here — scored against real live events.</p>
                </div>
              )}
              {matchResults && (
                <>
                  <p className="text-[10px] font-mono uppercase tracking-widest text-gold mb-4" data-testid="ai-match-count">{matchResults.matched} EVENTS MATCHED</p>
                  <div className="space-y-2.5 max-h-[380px] overflow-y-auto pr-1">
                    {matchResults.events.map((e) => (
                      <div key={e.id} className="flex items-center justify-between gap-3 bg-navy-950/70 border border-slate-800 rounded-sm px-4 py-3 hover:border-gold/40 transition-colors" data-testid={`match-result-${e.id}`}>
                        <div className="min-w-0">
                          <p className="text-sm font-semibold text-slate-100 truncate">{e.name}</p>
                          <p className="text-[10px] font-mono text-slate-500 mt-0.5">{e.city}, {e.country} · {e.dates}</p>
                        </div>
                        <span className={`shrink-0 font-mono text-xs font-bold px-2.5 py-1 rounded-sm border ${e.match >= 90 ? "text-emerald-400 border-emerald-500/40" : "text-gold border-gold/40"}`}>{e.match}% Match</span>
                      </div>
                    ))}
                    {matchResults.matched === 0 && <p className="text-sm text-slate-500 text-center py-8">No strong matches yet — broaden your industry or country.</p>}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* NETWORK */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 mt-16" data-testid="business-network">
        <h2 className="font-display text-2xl md:text-3xl font-bold text-slate-100 text-center">THE PEOPLE BEHIND THE EVENTS</h2>
        <p className="mt-2 text-center text-[10px] font-mono uppercase tracking-widest text-gold">Event → Company → Person → Opportunity</p>
        <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
          {NETWORK_ROLES.map((r) => (
            <div key={r} className="card-surface p-5 text-center hover:border-gold/40 hover:-translate-y-0.5 transition-all" data-testid={`network-role-${r.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <div className="w-10 h-10 mx-auto rounded-full bg-navy-800 border border-slate-700 flex items-center justify-center font-display font-bold text-gold text-sm">{r.charAt(0)}</div>
              <p className="mt-2.5 text-xs font-semibold text-slate-200">{r}</p>
            </div>
          ))}
        </div>
        <div className="text-center mt-8">
          <Link to="/members" data-testid="discover-network-btn" className="btn-gold text-xs">DISCOVER BUSINESS NETWORK <ArrowRight size={13} /></Link>
        </div>
      </section>

      {/* REGISTRATION BANNER */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 mt-16" data-testid="registration-banner">
        <div className="card-surface hairline-gold p-8 md:p-10 flex flex-wrap items-center justify-between gap-6">
          <div className="max-w-xl">
            <h2 className="font-display text-2xl md:text-3xl font-bold text-slate-100">ONE REGISTRATION. GLOBAL ACCESS.</h2>
            <p className="mt-2 text-sm text-slate-400">Create your 10XGLOBAL profile and discover, save, register and connect across international business events.</p>
          </div>
          <div className="flex flex-wrap gap-3">
            <Link to="/register" data-testid="create-profile-btn" className="btn-gold text-xs">CREATE FREE PROFILE</Link>
            <a href="#events-discovery" data-testid="banner-explore-btn" className="btn-outline text-xs">EXPLORE EVENTS</a>
          </div>
        </div>
      </section>

      {/* METRICS STRIP */}
      {m && (
        <section className="border-y border-slate-800 mt-16 bg-navy-900/40" data-testid="metrics-strip">
          <div className="max-w-7xl mx-auto px-4 md:px-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 divide-x divide-slate-800/60">
            <Counter value={m.global_events} label="Global Events" testid="metric-events" />
            <Counter value={m.countries} label="Countries" testid="metric-countries" />
            <Counter value={m.industries} label="Industries" testid="metric-industries" />
            <Counter value={m.professionals} label="Business Professionals" testid="metric-professionals" />
            <Counter value={m.potential_connections} label="Potential Connections" testid="metric-connections" />
            <Counter value={m.companies} label="Companies" testid="metric-companies" />
          </div>
        </section>
      )}

      {/* CALENDAR */}
      <section className="max-w-7xl mx-auto px-4 md:px-8 mt-16" data-testid="event-calendar">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-slate-100">EVENT CALENDAR</h2>
          <div className="flex gap-1.5" data-testid="calendar-tabs">
            {[["today", "Today"], ["week", "This Week"], ["month", "This Month"], ["upcoming", "Next 3 Months"]].map(([k, l]) => (
              <button key={k} onClick={() => setCalTab(k)} data-testid={`calendar-tab-${k}`}
                className={`text-[11px] font-mono uppercase tracking-wider px-3.5 py-2 rounded-sm border transition-colors ${calTab === k ? "border-gold text-gold bg-gold/10" : "border-slate-700 text-slate-400 hover:border-slate-500"}`}>{l}</button>
            ))}
          </div>
        </div>
        <div className="card-surface divide-y divide-slate-800" data-testid="calendar-rows">
          {calEvents.map((e) => (
            <div key={e.id} className="flex flex-wrap items-center gap-x-5 gap-y-2 px-5 py-4 hover:bg-navy-900/50 transition-colors" data-testid={`calendar-row-${e.id}`}>
              <div className="w-14 shrink-0 text-center border border-gold/30 rounded-sm py-1.5">
                <p className="font-mono text-[10px] text-gold uppercase">{new Date(e.start_date).toLocaleString("en", { month: "short" })}</p>
                <p className="font-display text-lg font-bold text-slate-100 leading-none">{e.start_date.slice(8, 10)}</p>
                <p className="font-mono text-[9px] text-slate-500">{e.start_date.slice(0, 4)}</p>
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-semibold text-slate-100 truncate">{e.name}</p>
                <p className="text-[10px] font-mono text-slate-500 mt-0.5 flex items-center gap-1"><MapPin size={10} />{e.city}, {e.country} · {e.type}</p>
              </div>
              <span className="text-[10px] font-mono uppercase tracking-widest text-techblue-light border border-techblue/30 px-2 py-1 rounded-sm hidden sm:inline">{e.industry}</span>
              <span className="font-mono text-xs font-bold text-gold hidden md:inline">{e.opportunity_score}<span className="text-slate-500 font-normal">/100 opp.</span></span>
              <button onClick={() => onRegister(e)} disabled={registeredIds.has(e.id)} data-testid={`calendar-register-${e.id}`}
                className={`btn-gold !px-4 !py-2 text-[11px] ${registeredIds.has(e.id) ? "opacity-60 cursor-default" : ""}`}>
                {registeredIds.has(e.id) ? "REGISTERED" : "REGISTER"}
              </button>
            </div>
          ))}
          {calEvents.length === 0 && <p className="px-5 py-10 text-center text-sm text-slate-500" data-testid="calendar-empty">No events in this window — try a wider range.</p>}
        </div>
      </section>

      {/* FINAL CTA */}
      <section className="relative mt-16 overflow-hidden" data-testid="events-final-cta">
        <img src={MAP_IMG} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy-950 via-navy-950/70 to-navy-950" />
        <div className="relative max-w-4xl mx-auto px-4 md:px-8 py-20 text-center">
          <h2 className="font-display text-3xl md:text-5xl font-extrabold tracking-tight text-slate-100 leading-tight">
            THE NEXT BUSINESS OPPORTUNITY<br />MAY ALREADY BE <span className="text-gold">ON YOUR CALENDAR.</span>
          </h2>
          <p className="mt-4 text-sm md:text-base text-slate-400">Discover where your industry is meeting next.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <a href="#events-discovery" data-testid="final-explore-btn" className="btn-gold text-xs">EXPLORE GLOBAL EVENTS <ArrowRight size={13} /></a>
            <Link to="/register" data-testid="final-register-btn" className="btn-outline text-xs">REGISTER WITH 10XGLOBAL</Link>
          </div>
          <p className="mt-8 text-[10px] font-mono uppercase tracking-widest text-slate-500">
            Organising an event? <Link to="/events/organiser/register" data-testid="final-organiser-link" className="text-gold hover:text-gold-light">Add it to 10XGLOBAL →</Link>
          </p>
        </div>
      </section>

      {/* MOBILE: bottom nav + floating register */}
      <nav className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-navy-950/95 backdrop-blur border-t border-slate-800 grid grid-cols-4" data-testid="events-mobile-nav">
        {[[Home, "Home", "/"], [Compass, "Explore", "/opportunities"], [CalendarDays, "Events", "/events"], [Gem, "Members", "/membership"]].map(([Icon, label, href]) => (
          <Link key={label} to={href} data-testid={`mobile-nav-${label.toLowerCase()}`}
            className={`flex flex-col items-center gap-1 py-2.5 text-[9px] font-mono uppercase tracking-wider ${label === "Events" ? "text-gold" : "text-slate-500"}`}>
            <Icon size={16} />{label}
          </Link>
        ))}
      </nav>
      <Link to="/register" data-testid="mobile-register-fab"
        className="md:hidden fixed bottom-16 right-4 z-40 w-12 h-12 rounded-full bg-gold text-navy-950 flex items-center justify-center shadow-2xl shadow-gold/30">
        <Plus size={20} strokeWidth={2.5} />
      </Link>
      <div className="md:hidden h-16" />
    </div>
  );
}
